import TabItem from '@cbgms/components/form/Tabs/TabItem'
import { ICompany, IShopByCompany } from '@cbgms/api'
import General from './General'
import Dashboard from './Dashboard'
import { useTranslation } from 'react-i18next'
import TabbedForm from '@cbgms/components/layout/TabbedForm'
import Licenses from 'app-support/company/components/Licenses/Licenses'
import { FormLayoutOuterProps } from '@cbgms/components/layout/FormLayout'

interface OuterProps {
  isEdit: boolean
  shops: IShopByCompany[]
}

interface Props extends OuterProps, Omit<FormLayoutOuterProps<ICompany>, 'DeleteModalContainer'> {}

const CompanyForm = ({ form, isEdit, shops, initialValues, ...rest }: Props) => {
  const { t } = useTranslation()
  return (
    <TabbedForm form={form} initialValues={initialValues} {...rest}>
      <TabItem name='dashboard' title={t('Company.DashboardTab')} hide={!isEdit}>
        <Dashboard shops={shops} />
      </TabItem>
      <TabItem title={t('Company.GeneralTab')} name='general'>
        <General />
      </TabItem>
      <TabItem title={t('Company.Licenses')} name='licenses' hide={!isEdit}>
        <Licenses />
      </TabItem>
    </TabbedForm>
  )
}

export default CompanyForm
